import { capitalCase } from "change-case";
import { FormControl, MenuItem, Select } from "@mui/material";
import { Job } from "generated/graphql";
import useJobsBillingStatuses from "hooks/jobs/useJobsBillingStatuses";
import useUpdateJobBillingStatus from "hooks/jobs/useUpdateJobBillingStatus";
import { SxProps, Theme } from "@mui/material/styles";

export default function BillingStatusSelection({
  billingStatus,
  jobId,
  sx,
}: {
  billingStatus: Job["billingStatus"];
  jobId: Job["id"];
  sx?: SxProps<Theme>;
}) {
  const { data: enumBillingStatus } = useJobsBillingStatuses();
  const [updateJobBillingStatus, { loading }] = useUpdateJobBillingStatus();

  const handleSubmit = (billingStatusSelected) => {
    updateJobBillingStatus({ variables: { id: jobId, billingStatus: billingStatusSelected } });
  };

  return (
    <FormControl
      variant="filled"
      sx={{
        minWidth: 240,
        ...sx,
      }}
    >
      <Select
        labelId="job-billing-status-label"
        id="job-billing-status"
        value={billingStatus}
        variant="standard"
        label=""
        disabled={loading}
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        sx={{
          "& .MuiSelect-select": {
            py: 0.25,
            pr: 3,
            textAlign: "left",
          },
        }}
      >
        {enumBillingStatus?.map((value) => (
          <MenuItem key={value} value={value}>
            {value ? capitalCase(value) : ""}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
